import {UserRoleContext} from './~context'

export const UserRoleProvider = UserRoleContext.Provider